// import React, { useMemo } from "react";
// import { Dropdown, Badge, Typography, Empty, Divider, Button } from "antd";
// import { ClockCircleOutlined } from "@ant-design/icons";
// import { getRecentItems } from "utils/recentItems";
// import { useNavigate } from "react-router-dom";

// const { Text } = Typography;

// const typeColors = {
//   project: "blue",
//   iteration: "purple",
//   task: "green",
// };

// const RecentItems = () => {
//   const navigate = useNavigate();
//   const items = useMemo(() => getRecentItems().slice(0, 8), []);

//   const menuItems = items.map((item) => ({
//     key: `${item.type}-${item.id}`,
//     label: (
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           gap: 2,
//         }}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//           <Badge color={typeColors[item.type] || "default"} />
//           <Text strong style={{ fontSize: 12, fontFamily: "Inter" }}>
//             {item.title}
//           </Text>
//         </div>

//         <Text
//           type="secondary"
//           style={{
//             fontSize: 11,
//             textTransform: "capitalize",
//             fontFamily: "Inter",
//           }}
//         >
//           {item.type}
//         </Text>
//       </div>
//     ),

//     // important part
//     onClick: () => {
//       if (item.type === "task") {
//         navigate(item.path, {
//           state: { openTaskId: item.id },
//         });
//       } else {
//         navigate(item.path);
//       }
//     },
//   }));

//   return (
//     <Dropdown
//       menu={{
//         items:
//           items.length > 0
//             ? menuItems
//             : [
//                 {
//                   key: "empty",
//                   label: (
//                     <div style={{ padding: "12px 8px" }}>
//                       <Empty
//                         image={Empty.PRESENTED_IMAGE_SIMPLE}
//                         description="No recently opened items"
//                       />
//                     </div>
//                   ),
//                   disabled: true,
//                 },
//               ],
//       }}
//       placement="bottomRight"
//       trigger={["click"]}
//       styles={{
//         root: {
//           width: 380,
//           height: 90,
//           overflowY: "auto",
//           borderRadius: 12,
//         },
//       }}
//     >
//       <Button icon={<ClockCircleOutlined />} className="recent-button">
//         Recent
//       </Button>
//     </Dropdown>
//   );
// };

// export default RecentItems;

import React, { useMemo, useState } from "react";
import { Dropdown, Badge, Typography, Empty, Button, Divider } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { getRecentItems, clearRecentItems } from "utils/recentItems";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useAuth } from "contexts/AuthContext";

dayjs.extend(relativeTime);

const { Text } = Typography;

const typeColors = {
  project: "blue",
  iteration: "purple",
  task: "green",
};

const RecentItems = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  //   const items = useMemo(() => getRecentItems().slice(0, 15), []);
  const [items, setItems] = useState(() =>
    getRecentItems(user.id).slice(0, 15),
  );

  const handleClick = (item) => {
    if (item.type === "task") {
      navigate(item.path, {
        state: { openTaskId: item.id },
      });
    } else {
      navigate(item.path);
    }
  };

  const handleClear = () => {
    clearRecentItems(user.id);
    setItems([]);
  };

  const dropdownContent =
    items.length > 0 ? (
      <div className="recent-dropdown">
        <div className="recent-scroll">
          {items.map((item) => (
            <div
              key={`${item.type}-${item.id}`}
              className="recent-dropdown-item"
              onClick={() => handleClick(item)}
            >
              <div className="recent-left">
                <Badge color={typeColors[item.type] || "default"} />
                <div className="recent-text">
                  <Text strong className="recent-title">
                    {item.title}
                  </Text>
                  <Text type="secondary" className="recent-type">
                    {item.type}
                  </Text>
                </div>
              </div>

              <Text type="secondary" className="recent-time">
                {dayjs(item.openedAt).fromNow()}
              </Text>
            </div>
          ))}
        </div>

        <Divider style={{ margin: 0 }} />

        <div className="recent-footer">
          <Button type="text" danger size="small" style={{fontSize:12, fontWeight: 500}} onClick={handleClear}>
            Clear recent
          </Button>
        </div>
      </div>
    ) : (
      <div style={{ padding: 16, background: "#fff" }} className="recent-empty">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No recently opened items"
        />
      </div>
    );

  return (
    <Dropdown
      popupRender={() => dropdownContent}
      placement="bottomRight"
      trigger={["click"]}
      styles={{
        root: {
          width: 360,
          borderRadius: 14,
          padding: 0,
        },
      }}
    >
      <Button icon={<ClockCircleOutlined />} className="recent-button">
        Recent
      </Button>
    </Dropdown>
  );
};

export default RecentItems;
